import {PERSON_ACTIVE_CONTEXTS_FOR_DISPLAY} from "../actions";

export default function(state = {}, action) {

//20190219
//payload is fuller dataset from db when already exists
//payload is just id from the new process -- from action createNewPersonForUser

  switch (action.type) {
    case PERSON_ACTIVE_CONTEXTS_FOR_DISPLAY:
      //console.log('rdcr_active_person_contexts_for_display action -- PERSON_ACTIVE_CONTEXTS_FOR_DISPLAY --', action.payload)
      return action.payload;
    default:
      return state;
  }
}
